module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1502-fc4cdfd15de0e2df989aa4cb41be1e10.png";